import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { PrivatePensionEntityNormalized } from '../../../../../../../../../store/product/types';
import { PrivatePensionAssetProvider } from '../../../../../contexts/products/PrivatePension';
import { ItemDetails } from '../Details';

import { PrivatePensionItemDesktop } from './desktop';
import { PrivatePensionItemMobile } from './mobile';
import { PrivatePensionItemTablet } from './tablet';

export namespace PrivatePensionItemTypes {
  export interface Props {
    offer: PrivatePensionEntityNormalized;
  }
}
export const PrivatePensionItem: React.FC<PrivatePensionItemTypes.Props> = (props) => {
  const privatePensionItem = useBreakpointValue({
    base: <PrivatePensionItemMobile {...props} />,
    sm: <PrivatePensionItemTablet {...props} />,
    lg: <PrivatePensionItemDesktop {...props} />,
  });

  return (
    <PrivatePensionAssetProvider>
      <ItemDetails />
      {privatePensionItem}
    </PrivatePensionAssetProvider>
  );
};
